import React, { useState, useCallback, forwardRef } from 'react';
import styled from 'styled-components';
import { Group, SearchOutlined, InputGroup, Input } from '@landr/maestro';
import { CollectionsList } from '../CollectionsList';

export interface CollectionsListPopoverProps
    extends React.HTMLAttributes<HTMLDivElement> {
    sampleIds?: string[];
    hide: () => void;
    placeholder?: string;
}

const Container = styled.div`
    height: 392px; /* @maestro-no-token */
    width: 320px;
    ${({ theme }): string => theme.breakpoint('md')`
        width: 100%;
    `};
`;

const CollectionsListPopover = forwardRef(
    (
        { sampleIds, hide, placeholder }: CollectionsListPopoverProps,
        ref: React.Ref<HTMLDivElement>,
    ) => {
        const [query, onSearch] = useState('');

        const onChange = useCallback(
            (e: React.ChangeEvent<HTMLInputElement>) =>
                onSearch(e.target.value),
            [onSearch],
        );

        return (
            <Container ref={ref}>
                <Group direction="vertical" pb="0" gutter="none">
                    <Group.Item p="sm">
                        <InputGroup>
                            <Input
                                size="md"
                                placeholder="Search"
                                value={query}
                                onChange={onChange}
                            />
                            <InputGroup.Icon placement="right">
                                <SearchOutlined />
                            </InputGroup.Icon>
                        </InputGroup>
                    </Group.Item>
                    <Group.Item>
                        <CollectionsList
                            sampleIds={sampleIds}
                            hide={hide}
                            searchString={query}
                            placeholder={placeholder}
                        />
                    </Group.Item>
                </Group>
            </Container>
        );
    },
);

export default CollectionsListPopover;
